<template>
    <modal-template>
        <template #header>
            <div>
                <div class="popup-header-title">
                    <span>administrators assigned to</span>
                </div>
                <div class="popup-header">
        <span>
          <span><sup>[<b>{{ participant.dairy.id }}</b>]</sup></span>
          <span>{{ participant.contact.name }}</span>
        </span>
                </div>
            </div>
            <div style="color:white;">{{ spacer }}</div>
        </template>
        <template #body>
            <div class="table-container">
                <table>
                    <thead>
                    <tr>
                        <th style="text-align:right;">
                            <input v-model="email"
                                   class="login-input"
                                   style="width:300px;"
                                   autofocus
                                   type="email"
                                   placeholder="new admin email address"
                                   size="30"
                                   autocomplete="off"
                                   :class="{'valid-email-address-format' : !validEmailAddress}"/>
                        </th>
                        <th class="control-icon-style" style="text-align:left;">
                            <tooltip-information text="add"
                                                 type="point-down">
                                <font-awesome-icon icon="user-plus"
                                                   v-on:click="add"/>
                            </tooltip-information>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="administrators.length === 0">
                        <tr style="font-weight:bold;">
                            <td colspan="2" style="text-align:center;">
                                <span>no administrators assigned</span>
                            </td>
                        </tr>
                    </template>
                    <tr v-for="administrator in administrators" :key="administrator.email">
                        <td>{{ administrator.email.trim() }}</td>
                        <td class="control-icon-style">
                            <tooltip-information text="remove"
                                                 type="point-right">
                                <font-awesome-icon icon="trash"
                                                   v-on:click="remove(administrator)"/>
                            </tooltip-information>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template #footer>
            <div style="float:left;">
                <button type="button" v-on:click="$emit('close', true)">close</button>
            </div>
        </template>
    </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import TooltipInformation from '@/components/tooltip/TooltipInformation'


export default {
    name: 'Administrator',
    props: ['participant'],
    emits: ['apierror', 'apierrortext'],
    data: function () {
        return {
            spacer: ' '.padEnd(60, 'X'),
            administrators: [],
            email: '',
            validEmailAddress: false,
        }
    },
    components: {
        ModalTemplate,
        TooltipInformation,
    },
    methods: {
        list: function () {
            this.axios
                .get("control/dairy/administrator/list", {
                    params: {
                        dairyId: this.participant.dairy.id,
                    }
                })
                .then(response => {
                    this.administrators = response.data
                })
                .catch(error => {
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })
        },
        add: function () {
            this.axios
                .get('email/isValid',
                    {
                        params: {
                            emailAddress: this.email
                        }
                    })
                .then(response => {
                    this.validEmailAddress = response.data


                    if (this.validEmailAddress) {
                        this.axios
                            .post("control/dairy/administrator/save", {
                                email: this.email,
                                dairyId: this.participant.dairy.id
                            })
                            .catch(error => {
                                this.validEmailAddress = false
                                this.setApiError(true)
                                this.setApiErrorText(error.response.statusText)
                            })
                            .finally(() => {
                                this.email = ''
                                this.list()
                            })
                    }
                })
                .catch(error => {
                    this.validEmailAddress = false
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })

                },
                    remove:function (administrator) {
                        this.axios
                    .post("control/dairy/administrator/remove", {
                        email: administrator.email,
                        dairyId: administrator.dairyId
                    })
                    .catch(error => {
                        this.setApiError(true)
                        this.setApiErrorText(error.response.statusText)
                    })
                    .finally(() => {
                        this.email = ''
                        this.list()
                    })
            }

        ,
            setApiError: function (isError) {
                this.$emit('apierror', isError)
            }
        ,
            setApiErrorText: function (text) {
                this.$emit('apierrortext', text)
            }
        ,
        },
        mounted() {
            this.validEmailAddress = true
            this.list()
        },
    }
</script>

<style scoped>
.valid-email-address-format {
    padding: 12px 15px;
    margin: 8px 0;
    width: 20%;
    font-size: 12pt;
    background: #ffdddd;
    border: 1px solid red;
}
</style>
